/**
 * ARIA Forgot Password Page
 * Version: 1.0.0
 */

import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useMutation, gql } from '@apollo/client';

const REQUEST_PASSWORD_RESET_MUTATION = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [requestPasswordReset, { loading }] = useMutation(REQUEST_PASSWORD_RESET_MUTATION);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await requestPasswordReset({ variables: { email } });
    } finally {
      // Always show the generic confirmation, regardless of outcome — don't
      // reveal whether the email matched an account.
      setSubmitted(true);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="card w-full max-w-sm p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="w-10 h-10 bg-brand-600 rounded-lg flex items-center justify-center mb-3">
            <span className="text-white font-bold">A</span>
          </div>
          <h1 className="text-lg font-semibold text-gray-900">Reset your password</h1>
        </div>

        {submitted ? (
          <p className="text-sm text-gray-600 text-center">
            If an account exists for that email, we've sent a link to reset your password.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-gray-600">
              Enter your email and we'll send you a link to reset your password.
            </p>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                id="email"
                type="email"
                autoComplete="username"
                required
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <p className="text-sm text-center text-gray-600 mt-6">
          <Link to="/login" className="text-brand-600 hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
